/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller_push.js                                                                  */
/**********************************************************************************************************************/

HafasWebapp.prototype.Controller.Push = {
  currentSubscription: null,
  weekdaySelection:null,
  menuSelectBoxes: [],
  temporaryWeekdaySelection: null,
  init: function(){
    if(typeof Hafas.Config.Push.channels["webpush"] != 'undefined' && Hafas.Config.Push.channels["webpush"]){
      _that= this;
      var n;
      var div =document.getElementById('status');

      // Wenn Webpush genutzt wird entsprechend Permissions einholen
      if(Hafas.Config.Push.channels.webpush.use == true) {
        if (!("Notification" in window)) {
          alert("This browser does not support desktop notification");
        } else if (Notification.permission === "granted") {
          // this.spawnNotification(Hafas.Modules.i18n.get('TP.index.t_N_WelcomeMessage'),Hafas.Config.imageLayoutPath + "customer/icon-152.png","Notification");
          _that.setUpServiceWorker();
        } else if (Notification.permission !== 'denied') {
          Notification.requestPermission(function (permission) {
            if (permission === "granted") {
              _that.setUpServiceWorker();
            }
          });
        }
      }
    }
  },
  setUpServiceWorker: function(){
    var endpoint;
    var key;
    var authSecret;
    function urlBase64ToUint8Array(base64String) {
      var padding = '='.repeat((4 - base64String.length % 4) % 4);
      var base64 = (base64String + padding)
          .replace(/\-/g, '+')
          .replace(/_/g, '/');

      var rawData = window.atob(base64);
      var outputArray = new Uint8Array(rawData.length);

      for (var i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
      }
      return outputArray;
    }

    // Register a Service Worker.
    navigator.serviceWorker.register("./js/_worker/haf_service-worker.js")
        .then(function(registration) {
          // Use the PushManager to get the user's subscription to the push service.
          return registration.pushManager.getSubscription()
              .then(function(subscription) {
                // If a subscription was found, return it.
                if (subscription) {
                  return subscription;
                }
                var vapidPublicKey = Hafas.Config.Push.channels.webpush.publicKey;
                var convertedVapidKey = urlBase64ToUint8Array(vapidPublicKey);

                // Otherwise, subscribe the user (userVisibleOnly allows to specify that we don't plan to
                // send notifications that don't have a visible effect for the user).
                return registration.pushManager.subscribe({
                  userVisibleOnly: true,
                  applicationServerKey: convertedVapidKey
                });
              });

        }).then(function(subscription) {
              var rawKey = subscription.getKey ? subscription.getKey('p256dh') : '';
              key = rawKey ? btoa(String.fromCharCode.apply(null, new Uint8Array(rawKey))) : '';
              var rawAuthSecret = subscription.getKey ? subscription.getKey('auth') : '';
              authSecret = rawAuthSecret ? btoa(String.fromCharCode.apply(null, new Uint8Array(rawAuthSecret))) : '';

              endpoint = subscription.endpoint;
              Hafas.Config.ClientEndPoint = endpoint;
              Hafas.Config.ClientKey = key;
              Hafas.Config.ClientPushAuth = authSecret;
    });

  },

  spawnNotification: function(theBody,theIcon,theTitle){
    var options = {
        body: theBody,
        icon: theIcon
    }
    n = new Notification(theTitle,options);
    setTimeout(n.close.bind(n), 8000);

    n.onshow = function() {
      // some code here if you want
    };

    n.onclick = function(event) {
      //window.open('http://www.google.com', '_blank');
      alert('Notification clicked');
    }
  },
  index: function(){
    if(Hafas.Modules.History)
      Hafas.Modules.History.addData("Push", "index", {});

    Hafas.Modules.Loader.loadTemplateFiles(['push.index.html'], Hafas.bind(function () {
      Hafas.bind(this.Controller.Push.renderIndex, this)();
    }, this));
  },
  renderIndex: function(){
    var me = this;
    var model = {};
    Hafas("#" + me.formContainer).innerHTML = Hafas.Modules.Render.renderTemplate("Push_TplIndex", model);

    me.Controller.Push.applicationSegCon = Hafas.Core.newType('HafasSegmentedControl', {
      holder: 'HFS_PushToggleMainApp',
      callback: Hafas.bind(me.Controller.Push.changeAlarmCenterTab,me)
    })
    me.Controller.Push.applicationSegCon.initiate();


    Hafas.ps.pub('/GUI/form/show', [{}]);
    Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
    Hafas.ps.pub('/app/events/resize');
    Hafas.ps.pub('/app/contextLoaded/' + me.appContext);

  },
  hidePushOverlay: function(data,subscrData,subscrId){
    //Hafas.bind(this.Controller.GUI.Push.cancel,this)();
    Hafas('[data-actionbutton="push"]',false).setAttribute("aria-checked",true);
    Hafas('[data-actionbutton="push"]',false).setAttribute("data-push-subscrId",subscrId);
    Hafas('[data-actionbutton="push"] i',false).className = 'haf_ic_quickaction_push_active';
  },
  getCurrentAlarmCenterUser: function(){
    var storage = Hafas.Core.newType("hafasStorage");
    var alarmCenterUser = storage.get('alarmUser_' + Hafas.Config.storageId);
    if(alarmCenterUser == null){
      return null;
    }else{
      var user = JSON.parse(alarmCenterUser);
      if(typeof user.userId == 'undefined'){
        return null;
      }else{
        return user;
      }
    }
  },
  setupAlarmType: function(data){
      // Alarm ist bereits aktiv und wird gelöscht
      if(data.active){
        if(typeof data.subscrId != 'undefined' && data.subscrId != null) {
          Hafas.ps.pub('/push/delete', [{ ctxRecon: data.ctxRecon, subscrId: data.subscrId, ctx:'overview'}]);
        }
      }else {
        // Alarm muss erst neu angelegt werden
        if (Notification.permission === "granted") {
          Hafas.bind(this.Controller.Push.setupAlarmSubscription, this)(data);
        } else {
          Notification.requestPermission(Hafas.bind(function (permission) {
            if (permission === "granted") {
              Hafas.bind(this.Controller.Push.setupAlarmSubscription, this)(data);
            }
          }, this));
        }
      }
  },
  setupAlarmSubscription: function(data){
    var alarmType = data.type;
    var alarmCenterUser = this.Controller.Push.getCurrentAlarmCenterUser();
    if(alarmCenterUser == null){
      Hafas.bind(this.Controller.Push.createNewAlarmCenterUser,this)(
          Hafas.bind(function(data){
            var user = this.Controller.Push.storeAlarmCenterUser(data);
            Hafas.Modules.Pushservice.getUserDetails({
              userId: user.userId
            }, Hafas.bind(this.Controller.Push.setupAlarm,this), function(){
              alert("User details konnten nicht abgerufen werden.");
            });
          },this),
          function(){ }
      );
    }else{
      Hafas.Modules.Pushservice.getUserDetails({
        userId: alarmCenterUser.userId
      }, Hafas.bind(this.Controller.Push.setupAlarm,this), function(){
        alert("User details konnten nicht abgerufen werden.");
      });
    }
  },
  getChannels: function(data,type){
   var channels = [];
   var result = data.svcResL[0].res.result;
   var availableChannels = data.svcResL[0].res.availableChannels;
   if(typeof availableChannels != 'undefined') {
     for (var a = 0; a < availableChannels.length; a++) {
       if (availableChannels[a].type == type) {
         channels.push(availableChannels[a]);
       }
     }
    }
    return channels;
  },
  setupAlarm: function(data,options){
    if(data.status.error == false && data.svcResL.length > 0) {
      if (data.svcResL[0].err == 'OK') {
        var currConn = this.Controller.Push.currentConnection;
        var currSub = this.Controller.Push.currentSubscription;
        var userId = data.svcResL[0].res.userId;
        //var channels = Hafas.bind(this.Controller.Push.getChannels();
        var channels = [];
        if(typeof currConn != 'undefined') {
          var connectionData = {
            depLocation: currConn.dep.locResolved.name,
            arrLocation: currConn.arr.locResolved.name,
            date: currConn.date,
            depTime: currConn.dep.dTimeS,
            arrTime: currConn.arr.aTimeS
          };
        }

        // Aufbereitung der zu speichernden Kanäle
        var channelsToUse = [];
        var currSubCh = this.Controller.Push.currentSubscription.channels;
        var currSubSettings = this.Controller.Push.currentSubscription.settings;
        var availableChannels = data.svcResL[0].res.availableChannels;
        for(var c in currSubCh){
            // In der Oberfläche
            if(currSubCh[c].use && currSubCh[c].checked){
               var subscriptionCh = {
                 type: c.toUpperCase(),
                 address: currSubCh[c].address,
                 active: true,
                 channelId: ''
               };
               // Prüfen ob es für diese Addresse und diesen Typ bereits einen Kanal gibt, dann kann die bisherige ChannelId genutzt werden
               if(typeof availableChannels != 'undefined') {
                 for (var ac = 0; ac < availableChannels.length; ac++) {
                   if (availableChannels[ac].type == c.toUpperCase() && availableChannels[ac].address == currSubCh[c].address) {
                     subscriptionCh = {channelId: availableChannels[ac].channelId};
                   }
                 }
               }
               channelsToUse.push(subscriptionCh);
            }
        }

        // Wenn es mindestens einen Kanal gibt, kann auch das Abo angelegt werden
        if (channelsToUse.length >= 0) {
          var subscriptionData = {
            type: 'conSubscr',
            userId: userId,
            channels: channels,
            channels: channelsToUse,
            hysteresis:{
              notificationStart: currSubSettings.notificationStart,
              minDeviationFollowing: currSubSettings.minDeviationFollowing,
              minDeviationInterval: currSubSettings.minDeviationInterval
            }
          };

          if(typeof connectionData != 'undefined'){
            subscriptionData.data = JSON.stringify(connectionData);
          }
          if(typeof currConn != 'undefined'){
            subscriptionData.ctxRecon = currConn.ctxRecon;
            subscriptionData.serviceDays = {
              beginDate: currConn.date,
              endDate: currConn.date
            }
          }

          if(typeof currSub.serviceDays != 'undefined'){
             if(typeof subscriptionData.serviceDays == 'undefined') {
               subscriptionData.serviceDays = {};
             }
             for(var s in currSub.serviceDays){
               subscriptionData.serviceDays[s] = currSub.serviceDays[s];
             }
             // Bei Wochentagsauswahl bis zum Ende der Fahrplanperiode überwachen
             if(typeof subscriptionData.serviceDays.selectedWeekdays != 'undefined' && subscriptionData.serviceDays.selectedWeekdays != null && subscriptionData.serviceDays.selectedWeekdays.indexOf("1") > -1){
               var hfsPeriodEnd = Hafas.Core.newType("hafasTime",{jsDate:Hafas.Config.periodEnd});
               subscriptionData.serviceDays.endDate = hfsPeriodEnd.format("YYYYMMDD");
             }else{
               subscriptionData.serviceDays.endDate = currConn.date;
             }
          }

          var pushServiceFunc = "addSubscription";

          if(typeof options != 'undefined' && options.update == true){
              subscriptionData.subscrId = this.Controller.Push.currentSubscription.subscrId;
              if(typeof this.Controller.Push.currentSubscription.conSubscr != 'undefined') {
                subscriptionData.ctxRecon = this.Controller.Push.currentSubscription.conSubscr.ctxRecon;
              }
              pushServiceFunc = "updateSubscription";
          }


          Hafas.Modules.Pushservice[pushServiceFunc](subscriptionData, Hafas.bind(function(data,subscrData){
                var resultCode = data.svcResL[0].res.result.resultCode;
                if(resultCode != 'ERROR') {
                  var subscrId = data.svcResL[0].res.subscrId;
                  Hafas.bind(this.Controller.Push.storeSubscription, this)(subscrData.ctxRecon, subscrId);

                  // Schritt aus der History löschen
                  Hafas.Modules.History.removeCurrentStep("createAlarm");

                  // Alarm wurde erfolgreich angelegt... Zurück zu den Verbindungsdetails
                  if(this.appContext == 'TP') {
                    Hafas.bind(this.Controller.TP.renderConnectionDetails, this)(this.Controller.TP.selectedConnection, {
                      connectionType: this.Controller.TP.activeSelection.connType,
                      arrayIdx: this.Controller.TP.activeSelection.arrayIdx
                    });
                  }else{
                    Hafas.bind(this.Controller.Push.renderIndex, this)();
                    Hafas.ps.pub('/GUI/form/show', [{}]);
                    Hafas.ps.pub('/GUI/results/overview/hide', [{}])
                    Hafas.ps.pub('/app/events/resize');
                  }

                  var saveAlarmUpdateMsg = Hafas.Modules.i18n.get('Push.result.t_N_Success');
                  if(typeof options != 'undefined' && options.update == true){
                    saveAlarmUpdateMsg = Hafas.Modules.i18n.get('Push.result.t_N_SuccessUpdate');
                  }
                  Hafas.ps.pub('/GUI/smallAlert/show', [saveAlarmUpdateMsg]);
                  Hafas.ps.pub('/push/subscriptionSuccess', [data, subscrData, subscrId]);
                }else{
                  Hafas.ps.pub('/GUI/smallAlert/show', [Hafas.Modules.i18n.get('Push.result.t_N_Failure')]);
                }

          },this,subscriptionData));
        }
      }
    }
  },
  /* Legt einen Rekonstruktionkontext ab, um gespeicherte Abos wiedererkennen zu können */
  storeSubscription: function(ctxRecon,subscrId){
    var storage = Hafas.Core.newType("hafasStorage");
    var pushSubscrStorageId = 'alarmSubscriptions_' + Hafas.Config.storageId;
    var subscriptions = storage.get(pushSubscrStorageId);
    var newSubscriptionObject = {};
    if(subscriptions != null) {
      newSubscriptionObject = JSON.parse(subscriptions);
    }
    //var b64encodedCtxRecon = Hafas.Util.b64EncodeUnicode(ctxRecon);
    newSubscriptionObject[ctxRecon] = subscrId;
    storage.set(pushSubscrStorageId,JSON.stringify(newSubscriptionObject));
  },
  deleteSubscriptionStorage: function(ctxRecon){
    var storage = Hafas.Core.newType("hafasStorage");
    var pushSubscrStorageId = 'alarmSubscriptions_' + Hafas.Config.storageId;
    var subscriptions = storage.get(pushSubscrStorageId);
    var newSubscriptionObject = {};
    if(subscriptions != null) {
      newSubscriptionObject = JSON.parse(subscriptions);
      if(typeof newSubscriptionObject[ctxRecon] != 'undefined'){
          delete newSubscriptionObject[ctxRecon];
          storage.set(pushSubscrStorageId,JSON.stringify(newSubscriptionObject));
      }
    }
  },
  storeAlarmCenterUser: function(data){
    var storage = Hafas.Core.newType("hafasStorage");
    if(data.status.error == false && data.svcResL.length > 0){
       if(data.svcResL[0].err == 'OK'){
          var result = data.svcResL[0].res.result;
          var userId = data.svcResL[0].res.userId;
       }
    }
    var alarmCenterUser = {userId: userId};
    storage.set('alarmUser_' + Hafas.Config.storageId, JSON.stringify(alarmCenterUser));
    return alarmCenterUser;
  },
  createNewAlarmCenterUser: function(callback,errorCallback){
    Hafas.Modules.Pushservice.createUser({
      availableChannels: [],
      language: Hafas.Config.currLangObj.iso
    }, callback, errorCallback);
  },
  changeAlarmCenterTab: function(data){
    // var renderTpl = 'Push_TplIndex_Subscriptions';
    var view = 'subscriptions';
    if(data.activeIndex == 1){
      view = 'history';
    }

    if(view == 'subscriptions'){
       Hafas.bind(this.Controller.Push.renderSubscriptionOverview,this)(data);
    }else {
       Hafas.bind(this.Controller.Push.renderHistoryOverview,this)(data);
    }
    Hafas.ps.pub('/app/events/resize');
  },
  renderSubscriptionOverview: function(data){
    // mögliche temporäre Wochentagsauswahl zurücksetzen
    this.Controller.Push.weekdaySelection = null;
    this.Controller.Push.temporaryWeekdaySelection = null;

    var renderTpl = 'Push_TplIndex_Subscriptions';
    var view = 'subscriptions';
    var self = this;

    var model = {
      activeAlarmTypes: []
    };

    var pushMenuSelection = data.trigger.getAttribute('data-pushtab');
    var currentTarget = data.target;

    function reRenderAlarmCenter(model){
      currentTarget.innerHTML = Hafas.Modules.Render.renderTemplate(renderTpl, model);

      var alarmCenterUser = self.Controller.Push.getCurrentAlarmCenterUser();
      if(alarmCenterUser != null) {
      Hafas.Modules.Pushservice.getUserDetails({
        userId: alarmCenterUser.userId
      },Hafas.bind(function(userDetails) {
        var userResult = userDetails.svcResL[0].res;
        // prüfen, ob alarme pausieren
        if(typeof userResult != 'undefined' && typeof userResult.pauseBegin != 'undefined'){
          Hafas('#HFS_PushPauseAlarms',false).checked = true;
        }
      },this));
      }

      Hafas.ps.pub('/app/events/resize');
    }

    var alarmCenterUser = this.Controller.Push.getCurrentAlarmCenterUser();
    if (Hafas.Config.Push.basicSingleTrip) {
      model.activeAlarmTypes.push({
        type: 'basicSingleTrip',
        label: Hafas.Modules.i18n.get('Push.index.t_N_TripAlarms'),
        hciType: 'conSubscrL',
        subscriptions: []
      });
    }
    if(alarmCenterUser != null) {
      Hafas.Modules.Pushservice.listSubscriptions({userId: alarmCenterUser.userId}, Hafas.bind(function(subscriptionResults){
        if(subscriptionResults.svcResL[0].err == "OK") {
          for (var s = 0; s < model.activeAlarmTypes.length; s++) {
            model.activeAlarmTypes[s].subscriptions = this.Controller.Push.getSubscriptionData(subscriptionResults, model.activeAlarmTypes[s].hciType);
            model.activeAlarmTypes[s].subscriptionsDetails = [];
            var subscriptionIds = [];
            for (var m = 0; m < model.activeAlarmTypes[s].subscriptions.length; m++) {
              subscriptionIds.push(model.activeAlarmTypes[s].subscriptions[m].subscrId);
            }
            // Details zu den Push Meldungen abrufen
            if (subscriptionIds.length > 0) {
              Hafas.Modules.Pushservice.getSubscriptionDetails({
                subscriptionIds: subscriptionIds,
                userId: alarmCenterUser.userId
              }, Hafas.bind(function (subscriptionDetails, idx) {
                for (var d = 0; d < subscriptionDetails.svcResL.length; d++) {
                  var currentResult = subscriptionDetails.svcResL[d];
                  model.activeAlarmTypes[idx].subscriptionsDetails.push(currentResult.res);
                }
                reRenderAlarmCenter(model);
              }, this, s))
            } else {
              reRenderAlarmCenter(model);
            }
          }
        }else{
          model.errorCode = subscriptionResults.svcResL[0].err;
          model.errorTxt = Hafas.Modules.i18n.get('Push.error.t_N_' + model.errorCode);
          reRenderAlarmCenter(model);
        }
      },this));
    }else{
      reRenderAlarmCenter(model);
    }
  },
  prepareHistoryMessageList: function(subscriptionDetails){
    var msgList = [];
    if(typeof subscriptionDetails.svcResL != 'undefined') {
      for (var d = 0; d < subscriptionDetails.svcResL.length; d++) {
        var currentResult = subscriptionDetails.svcResL[d].res;
        if (typeof currentResult.eventHistory.himEvents != 'undefined') {
          for (var h = 0; h < currentResult.eventHistory.himEvents.length; h++) {
            var tmpHimEvent = currentResult.eventHistory.himEvents[h];
            tmpHimEvent.hciTimestamp = Hafas.Util.date.ISODateToHCIDate(tmpHimEvent.received);
            var hciTimeObject = Hafas.Core.newType("hafasTime", {
              date: tmpHimEvent.hciTimestamp.hciDate,
              time: tmpHimEvent.hciTimestamp.hciTime
            });
            tmpHimEvent.jsTimestamp = hciTimeObject.getJsDate();
            msgList.push(tmpHimEvent);
          }
        }
        if (typeof currentResult.eventHistory.rtEvents != 'undefined') {
          for (var r = 0; r < currentResult.eventHistory.rtEvents.length; r++) {
            var tmpRtEvent = currentResult.eventHistory.rtEvents[r];
            tmpRtEvent.hciTimestamp = Hafas.Util.date.ISODateToHCIDate(tmpRtEvent.received);
            var hciTimeObject = Hafas.Core.newType("hafasTime", {
              date: tmpRtEvent.hciTimestamp.hciDate,
              time: tmpRtEvent.hciTimestamp.hciTime
            });
            tmpRtEvent.jsTimestamp = hciTimeObject.getJsDate();
            msgList.push(tmpRtEvent);
          }
        }
      }
    }
    msgList.sort(function(a,b){
      return b.jsTimestamp.getTime() - a.jsTimestamp.getTime();
    });
    return msgList;
  },
  renderHistoryOverview: function(data){
     var renderTpl = 'Push_TplIndex_History';
     var model = {};
     var currentTarget = data.target;
     var alarmCenterUser = this.Controller.Push.getCurrentAlarmCenterUser();
     if(alarmCenterUser != null) {
        Hafas.Modules.Pushservice.listSubscriptions({userId: alarmCenterUser.userId}, Hafas.bind(function(subscriptionResults){
            var subscriptions = this.Controller.Push.getSubscriptionData(subscriptionResults,'conSubscrL');
            var subscriptionIds = [];
            for(var m=0; m < subscriptions.length;m++){
              subscriptionIds.push(subscriptions[m].subscrId);
            }
            Hafas.Modules.Pushservice.getSubscriptionDetails({
              subscriptionIds: subscriptionIds,
              userId: alarmCenterUser.userId
            }, Hafas.bind(function (subscriptionDetails, idx) {
              //model.msgList = msgList;
              model.msgList = this.Controller.Push.prepareHistoryMessageList(subscriptionDetails);
              currentTarget.innerHTML = Hafas.Modules.Render.renderTemplate(renderTpl, model);
              Hafas.ps.pub('/app/events/resize',[]);
            },this));

        },this))
     }else {
       currentTarget.innerHTML = Hafas.Modules.Render.renderTemplate(renderTpl, model);
     }
  },
  getSubscriptionData: function(data,type){
      var subscriptionData = [];
      if(data.svcResL.length > 0 && data.svcResL[0].err == "OK"){
         var result = data.svcResL[0].res;
         if(typeof result[type] != 'undefined'){
           subscriptionData = result[type];
         }
      }
      return subscriptionData;
  },
  showMessages: function(data){
     // TODO Alle Meldungen zu einer Subscription
    var renderTpl = 'Push_TplIndex_SubscriptionHistory';
    var alarmCenterUser = this.Controller.Push.getCurrentAlarmCenterUser();
    var currentTarget = Hafas('#Push_Result',false);
    var model = {};
    if(alarmCenterUser != null) {
      Hafas.Modules.Pushservice.getSubscriptionDetails({
        subscriptionIds: [data.subscrId],
        userId: alarmCenterUser.userId
      }, Hafas.bind(function (subscriptionDetails, idx) {
        var result = subscriptionDetails.svcResL[0].res;
        //model.msgList = msgList;
        model.conSubscr = result.conSubscr;
        model.hideCaret = true;
        model.msgList = this.Controller.Push.prepareHistoryMessageList(subscriptionDetails);
        currentTarget.innerHTML = Hafas.Modules.Render.renderTemplate(renderTpl, model);
        Hafas.ps.pub('/GUI/form/hide', [{appcontext: "Push"}]);
        Hafas.ps.pub('/GUI/results/overview/show', [{}]);
        Hafas.ps.pub('/app/events/resize');

      }, this));
    }

    if(Hafas.Modules.History) {
      Hafas.Modules.History.addOrUpdateData("Push", "subscriptionHistory", data);
    }


  },
  showDetails: function(data){
    Hafas.ps.pub('/tp/searchReconstruction', [data.ctxRecon, "ctxRecon", {showDetails: true}]);
    Hafas.ps.pub('/app/switchContext',[{context:'TP',method:'index'}]);
    Hafas.ps.pub('/GUI/form/hide', [{appcontext: 'TP'}]);
  },
  showAlternatives: function(data){
     // Hier muss ein bisschen getrickst werden, um Start/Ziel zu füllen
     Hafas.ps.pub('/app/switchContext',[{context:'TP', method:'index'}]);
     var fillAttempts = 0;
     var fillFormValues = Hafas.bind(function(tmpData){
       return function() {
         if(Hafas('#From',false) != null) {
           Hafas('#From', false).value = tmpData.start;
           Hafas('#To', false).value = tmpData.dest;
           Hafas.bind(this.Controller.TP.postForm,this)({form:Hafas('#HFS_FormTripSearch')});
         }else{
           if(fillAttempts < 10) {
             window.setTimeout(function () {
               fillFormValues(tmpData);
               fillAttempts++
             }, 100);
           }
         }
       }
     }(data),this);
     this.Controller.TP.instance.setTimeNow(false);
     this.Controller.TP.instance.setOutTime(data.depTime);
     this.Controller.TP.instance.setOutDate(data.depDate);
     fillFormValues();
  },
  createDefaultSubscription: function(){
    this.Controller.Push.currentSubscription = {
      settings: Hafas.Core.clone(Hafas.Config.Push.settings),
      channels: Hafas.Core.clone(Hafas.Config.Push.channels),
      repeat: null
    };
  },
  selectChannel: function(data){
      this.Controller.Push.currentSubscription.channels[data.id].checked = data.checked;
      if(Hafas('#pushChannelInput_' + data.id)) {
        Hafas('#pushChannelInput_' + data.id).focus();
      }
      var channelSelected = false;
      for(var c in this.Controller.Push.currentSubscription.channels){
          var ch = this.Controller.Push.currentSubscription.channels[c];
          if(typeof ch.checked != 'undefined' && ch.checked == true){
            channelSelected = true;
          }
      };
      Hafas('#push_saveBtn',false).disabled = !channelSelected;
  },
  validateChannelInput: function(data){
    var currSub = this.Controller.Push.currentSubscription;
    var channelInputField = Hafas('#pushChannelInput_' + data.id);
    if(channelInputField){
      var valid = false;
      switch(data.id){
        case "email": valid = Hafas.Util.validateEmail(channelInputField.value);break;
        case "sms": valid = true; break; // TODO Sinnvoller Mobilfunknummercheck
      }
      // Wenn Eingabe gültig, dem aktuellen Subscription Objekt hinzufügen
      if(valid){
         currSub.channels[data.id].address = channelInputField.value;
      }
    }
  },
  changeNotificationOption: function(selectedOption){
    var currSub = this.Controller.Push.currentSubscription;
    currSub.settings.notificationStart = parseInt(selectedOption.value);
  },
  changeDelayOption: function(selectedOption){
    var currSub = this.Controller.Push.currentSubscription;
    currSub.settings.minDeviationFollowing = parseInt(selectedOption.value);
    currSub.settings.minDeviationInterval = parseInt(selectedOption.value);
  },
  showEditDialog: function(data){
    var me = this;
    var viewCtx = 'Push';
    if(data.origin == 'TP'){
      viewCtx = 'TP';
    }

    var user = this.Controller.Push.getCurrentAlarmCenterUser();

    var _targetTemplate = 'Push_Result';
    if(viewCtx == 'TP'){
      _targetTemplate = 'TP_ResultDetail';
    }
    Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
    Hafas.ps.pub('/GUI/results/details/show', [{}]);

    // Loading Spinner anzeigen
    Hafas.Modules.Render.render({
      file: 'push.index.html',
      target: _targetTemplate,
      template: 'Push_TplLoadingScreen',
      model: {}
    }, function (html) {
      Hafas.ps.pub('/app/events/resize', []);
    });

    // Subscription Details laden, um Edit Dialog
    Hafas.Modules.Pushservice.getSubscriptionDetails({
      userId: user.userId,
      subscriptionIds: [data.subscrId]
    }, Hafas.bind(function(dataSubscription){
          Hafas.bind(this.Controller.Push.preProcessSubscription,this)(dataSubscription,data.subcrId,viewCtx);
          Hafas.bind(this.Controller.Push.renderEditDialog,this)();
       },this),
        function(err){
         console.log("*** err *** ", err);
    });

    if(Hafas.Modules.History && viewCtx != 'TP') {
      Hafas.Modules.History.addOrUpdateData(viewCtx, "edit", data);
    }

    Hafas.ps.pub('/GUI/form/hide', [{appcontext: viewCtx}]);
    // Im Push Kontext muss die Overview angezeigt werden
    if(viewCtx == 'Push') {
      Hafas.ps.pub('/GUI/results/overview/show', [{}]);
    }
    Hafas.ps.pub('/app/events/resize');
  },
  preProcessSubscription: function(data,subscrId,viewCtx){
    var result = null;
    var pushCfg = Hafas.Config.Push;
    // Prüfen auf gültiges Subscription Ergebnis
    if(data.svcResL.length > 0 && data.svcResL[0].err == "OK"){
      result = data.svcResL[0].res;
    }

    // Subscription Objekt aufbauen
    this.Controller.Push.currentSubscription = {
      settings: Hafas.Core.clone(pushCfg.settings),
      channels: Hafas.Core.clone(pushCfg.channels),
      availableChannels: []
    };

    if(result != null) {
      this.Controller.Push.currentSubscription.subscrId = result.subscrId;
    }

    // Subscription Objekt mit Daten aus dem Server füllen
    // Durch bestehende Abo channels iterieren und Array für verfügbare Kanäle hinzufügen
    for(var c in this.Controller.Push.currentSubscription.channels){
      var tmpCh = this.Controller.Push.currentSubscription.channels[c];
      if(tmpCh.use == true){
        var currentChannelObj = {
          type: c,
          id: c
        };
        if(result != null && result.channels !== undefined){
          for(var a = 0; a < result.channels.length;a++){
            if(result.channels[a].type.toLowerCase() == c){
              currentChannelObj.address = result.channels[a].address;
              currentChannelObj.checked = result.channels[a].active;
              currentChannelObj.channelId = result.channels[a].channelId;
              tmpCh.checked = result.channels[a].active;
              tmpCh.address = result.channels[a].address;
              tmpCh.channelId = result.channels[a].channelId;
            }
          }
        }
        this.Controller.Push.currentSubscription.availableChannels.push(currentChannelObj);
      }
    }

    var conSubscr = result.conSubscr;
    this.Controller.Push.currentSubscription.conSubscr = result.conSubscr;
    if(typeof conSubscr != 'undefined' && typeof conSubscr.hysteresis != 'undefined'){
      for(var h in conSubscr.hysteresis){
        this.Controller.Push.currentSubscription.settings[h] = conSubscr.hysteresis[h];
      }
    }

    /* Servicedays aus Abo auslesen */
    if(typeof conSubscr != 'undefined' && typeof conSubscr.serviceDays != 'undefined'){
      this.Controller.Push.currentSubscription.serviceDays = conSubscr.serviceDays;
    }
  },
  initSelectBoxes: function(){
    this.Controller.Push.menuSelectBoxes = [];
    var notificationSelBox = Hafas.Core.newType('HafasSelectBox', {holder: 'HFS_PushNotificationOptions_Holder', callback: function(data){
        Hafas.ps.pub('/push/changeNotificationOption',[data]);
      }}).initiate();
    this.Controller.Push.menuSelectBoxes.push(notificationSelBox);

    var delaySelBox = Hafas.Core.newType('HafasSelectBox', {holder: 'HFS_PushDelayOptions_Holder', callback: function(data){
        Hafas.ps.pub('/push/changeDelayOption',[data]);
      }}).initiate();
    this.Controller.Push.menuSelectBoxes.push(delaySelBox);
  },
  renderEditDialog: function(){
    var pushCfg = Hafas.Config.Push;
    var _targetTemplate = 'Push_Result';
    var currentSubscription = this.Controller.Push.currentSubscription;
    var viewCtx = this.appContext;

    var model = {
      subscrId: currentSubscription.subscrId
    };

    if(currentSubscription.conSubscr && currentSubscription.conSubscr.ctxRecon) {
      model.ctxRecon = currentSubscription.conSubscr.ctxRecon;
    }

    if(typeof currentSubscription.availableChannels != 'undefined') {
      model.availableChannels = currentSubscription.availableChannels;
    }

    /* Repetition */
    var conSubscr = currentSubscription.conSubscr;
    var repeatStatus = 'never';

    /* Wenn in der aktuellen Bearbeitung neue Wochentage gesetzt worden sind, die Serverwerte mit diesen überschreiben */
    if(typeof this.Controller.Push.weekdaySelection != 'undefined' && this.Controller.Push.weekdaySelection != null){
      if(typeof conSubscr.serviceDays == 'undefined'){
        conSubscr.serviceDays = {};
      }
      conSubscr.serviceDays.selectedWeekdays = this.Controller.Push.weekdaySelection;
    }

    /* Status der Wiederholung ermitteln */
    if(typeof conSubscr != 'undefined' && typeof conSubscr.serviceDays != 'undefined'){
       if(typeof conSubscr.serviceDays.selectedWeekdays != "undefined"){
          repeatStatus = 'weekdays';
       }
    }

    // Texte für die ausgewählten Wochentage für die Oberfläche generieren
    if(repeatStatus == 'never'){
        model.repeatStatusText = Hafas.Modules.i18n.get('Push.index.t_N_RepeatNever');
    }else if(repeatStatus == 'weekdays'){
        var repeatData = this.Controller.Push.getRepeatStatusFromSubscription(conSubscr);
        model.repeatStatusText = repeatData.repeatStatusText;
        model.repeatStatusTextLong = repeatData.repeatStatusTextLong;
    }

    // Werte aus bestehendem Abo auslesen
    model.notificationOptions = [];
    for(var n=0; n < pushCfg.settings.notificationStartOptions.length;n++){
      var notificationValue = pushCfg.settings.notificationStartOptions[n];
      var selected = (notificationValue == this.Controller.Push.currentSubscription.settings.notificationStart)?true:false;
      model.notificationOptions.push({
        value: notificationValue,
        label: Hafas.Modules.i18n.get('Push.result.t_N_EditFromXMinutes',{ min: notificationValue} ),
        selected: selected
      });
    }

    model.delayOptions = [];
    for(var d=0; d < pushCfg.settings.delayOptions.length;d++){
      var delayValue = pushCfg.settings.delayOptions[d];
      var selected = (delayValue == this.Controller.Push.currentSubscription.settings.minDeviationInterval)?true:false;
      model.delayOptions.push({
        value: delayValue,
        label: Hafas.Modules.i18n.get('Push.result.t_N_EditFromXMinutes',{ min: delayValue} ),
        selected: selected
      });
    }

    /* Für Edit aus TP wird ein anderer Zweig angesprochen, da die Eingabemaske in einem separaten Container angezeigt wird */
    if(viewCtx == 'TP'){
      Hafas.Modules.History.addOrUpdateData("TP", "createAlarm", {});
      _targetTemplate = 'TP_ResultDetail';

      Hafas.Modules.Render.render({
        file: 'push.index.html',
        target: _targetTemplate,
        template: 'Push_TplEditSubscription',
        model: model
      }, Hafas.bind(function (html) {
         Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
         Hafas.ps.pub('/GUI/results/details/show', [{}]);

         Hafas.bind(this.Controller.Push.initSelectBoxes,this)();

         Hafas.ps.pub('/app/events/resize', []);
      },this));
      Hafas.ps.pub('/app/events/resize', []);
    }else {
      Hafas("#" + _targetTemplate).innerHTML = Hafas.Modules.Render.renderTemplate("Push_TplEditSubscription", model);
      Hafas.bind(this.Controller.Push.initSelectBoxes,this)();
    }
    Hafas.ps.pub('/app/events/resize');
  },
  saveSubscription: function(data){
      var errorMsgs = [];
      var channelSelectCount = 0;
      var currSub = this.Controller.Push.currentSubscription;
      var usedChannelCount = 0;
      for(var c in currSub.channels){
        if(currSub.channels[c].use){
          usedChannelCount++;
        }
      }
      for(var c in currSub.channels){
          // Wenn insgesamt nur ein Kanal verfügbar ist, wird dieser automatisch ausgewählt
          if(usedChannelCount){
            currSub.channels[c].checked = true;
          }
          if(currSub.channels[c].checked && currSub.channels[c].use){
            channelSelectCount++;
            if(typeof currSub.channels[c].address == 'undefined' || currSub.channels[c].address.length == 0){
              errorMsgs.push({
                type:'NO_CHANNEL_ADDRESS',
                label: Hafas.Modules.i18n.get('Push.index.t_N_FillInfo_' + c)
              });
            }
          }
      }
      if(channelSelectCount == 0){
        errorMsgs.push({
          type:'NO_CHANNELS_SELECTED',
          label: Hafas.Modules.i18n.get('Push.index.t_N_SelectAChannel')
        });
      }
      if(errorMsgs.length == 0){
          // Save Button deaktivieren
          if(Hafas('#push_saveBtn',false)) {
            Hafas('#push_saveBtn', false).disabled = true;
          }

          // Prüfen, ob es schon einen aktuellen User gibt
          var alarmCenterUser = this.Controller.Push.getCurrentAlarmCenterUser();

          // Alarmcenter User ist bereits im LocalStorage hinterlegt ==> Details über HCI abfragen
          if(alarmCenterUser != null){
            Hafas.Modules.Pushservice.getUserDetails({
              userId: alarmCenterUser.userId
            }, Hafas.bind(function(userData){
                // Prüfen, ob Subscription angelegt oder aktualisiert werden muss
                if(typeof data != 'undefined' && typeof data.subscrId != 'undefined'){
                  Hafas.bind(this.Controller.Push.setupAlarm,this)(userData,{update:true});
                }else {
                  // Neuen Alarm anlegen
                  Hafas.bind(this.Controller.Push.setupAlarm,this)(userData);
                }
              },this),
              Hafas.bind(function(errorMsg){
                 console.log("An error has occured while creating an alarmcenter user.");
            },this));
          }else{
            Hafas.bind(this.Controller.Push.createNewAlarmCenterUser,this)(
                Hafas.bind(function(data){
                  if(data.errorStatus != 'ERROR' && data.svcResL.length > 0) {
                  var user = this.Controller.Push.storeAlarmCenterUser(data);
                  Hafas.Modules.Pushservice.getUserDetails({
                    userId: user.userId
                  }, Hafas.bind(this.Controller.Push.setupAlarm,this), function(errorMsg){
                        console.log("An error has occured while creating an alarmcenter user.");
                  });
                  }else{
                    errorMsgs.push({
                      type:'SERVER_ERROR',
                      label: Hafas.Modules.i18n.get('Push.error.t_N_ServerException')
                    });
                    Hafas('#HFS_PushErrorWrapper',false).innerHTML = Hafas.Modules.Render.renderTemplate("Push_TplErrorList", {errorMsgs: errorMsgs});

                    // Save Button wieder aktiv schalten
                    if(Hafas('#push_saveBtn',false)) {
                      Hafas('#push_saveBtn', false).disabled = false;
                    }
                  }
                },this),
                function(errCreateUserRequestErr){

                }
            );
          }
      }
      if(errorMsgs.length > 0){
        Hafas('#HFS_PushErrorWrapper',false).innerHTML = Hafas.Modules.Render.renderTemplate("Push_TplErrorList", {errorMsgs: errorMsgs});
      }else{
        Hafas('#HFS_PushErrorWrapper',false).innerHTML = "";
      }
  },
  deleteSubscription: function(data){
    // Delete Button deaktivieren
    if(Hafas('#push_deleteBtn',false)) {
      Hafas('#push_deleteBtn', false).disabled = true;
    }

     var alarmCenterUser = this.Controller.Push.getCurrentAlarmCenterUser();
      if(typeof data.subscrId != 'undefined'){
         Hafas.Modules.Pushservice.deleteSubscription({subscriptionId: data.subscrId, userId: alarmCenterUser.userId }, Hafas.bind(function(subscrDeleteData){
           this.Controller.Push.deleteSubscriptionStorage(data.ctxRecon);
           if(typeof data.ctx == 'undefined' && this.appContext != 'TP') {
             Hafas.bind(this.Controller.Push.renderIndex, this)();
             Hafas.ps.pub('/GUI/form/show', [{}]);
             Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
             Hafas.ps.pub('/app/events/resize');
           }else{
             // Schritt aus der History löschen
             Hafas.Modules.History.removeCurrentStep("createAlarm");
             
             // Alarm wurde erfolgreich gelöscht ... Zurück zu den Verbindungsdetails
             Hafas.bind(this.Controller.TP.renderConnectionDetails,this)(this.Controller.TP.selectedConnection,{
               connectionType: this.Controller.TP.activeSelection.connType,
               arrayIdx: this.Controller.TP.activeSelection.arrayIdx
             });
           }
         },this));
      }
  },
  showRepeatOptions: function(data){
    Hafas.Modules.History.addOrUpdateData("Push", "repeatOptions", {});
    var periodBeginJS = Hafas.Config.periodBegin;
    var periodEndJS = Hafas.Config.periodEnd;
    var periodBeginHfs = Hafas.Core.newType("hafasTime",{jsDate: periodBeginJS});
    var periodEndHfs = Hafas.Core.newType("hafasTime",{jsDate: periodEndJS});
    var _targetTemplate = Hafas('#Push_Result',false);
    if(this.appContext == 'TP'){
      _targetTemplate = 'TP_ResultDetail';
    }
    var model = {
      repeatHintText: Hafas.Modules.i18n.get('Push.result.t_N_RepeatHintText',{period_start: periodBeginHfs.format("L"), period_end: periodEndHfs.format("L")}),
      weekdays: [
        {label: Hafas.Modules.i18n.get('common.weekdays.t_N_Monday')},
        {label: Hafas.Modules.i18n.get('common.weekdays.t_N_Tuesday')},
        {label: Hafas.Modules.i18n.get('common.weekdays.t_N_Wednesday')},
        {label: Hafas.Modules.i18n.get('common.weekdays.t_N_Thursday')},
        {label: Hafas.Modules.i18n.get('common.weekdays.t_N_Friday')},
        {label: Hafas.Modules.i18n.get('common.weekdays.t_N_Saturday')},
        {label: Hafas.Modules.i18n.get('common.weekdays.t_N_Sunday')}
      ]
    };
    model.currentSubscription = this.Controller.Push.currentSubscription;
    if(typeof data != 'undefined' && typeof data.subscrId != 'undefined'){
      model.subscrId = data.subscrId;
    }

    Hafas.Modules.Render.render({
      file: 'push.index.html',
      target: _targetTemplate,
      template: 'Push_TplRepeatSubscription',
      model: model
    }, function (html) {
      // Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
      // Hafas.ps.pub('/GUI/results/details/show', [{}]);
      Hafas.ps.pub('/app/events/resize', []);
    });

    //me.Controller.Push.currentView = "repeatOptions";
  },
  getRepeatStatusFromSubscription: function(subscription){
    var data = {};
    if(typeof subscription.serviceDays == 'undefined' || typeof subscription.serviceDays.selectedWeekdays == 'undefined' || subscription.serviceDays.selectedWeekdays == null) {
      data.repeatStatus = 'never';
      data.repeatStatusText = Hafas.Modules.i18n.get('Push.index.t_N_RepeatNever');
      data.repeatStatusTextLong = Hafas.Modules.i18n.get('Push.index.t_N_RepeatNever');
    }else{
      var weekdays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday','Saturday', 'Sunday'];
      var wdStatusText = '';
      var wdStatusTextLong = '';
      var selWeekDays = subscription.serviceDays.selectedWeekdays;
      for (var i = 0; i < selWeekDays.length; i++) {
        var currentWD = selWeekDays.charAt(i);
        if(currentWD == "1"){
          if(wdStatusText.length > 0){
            wdStatusText += ", ";
            wdStatusTextLong += ', ';
          }
          wdStatusText += Hafas.Modules.i18n.get('common.weekdays.t_S_' + weekdays[i]);
          wdStatusTextLong += Hafas.Modules.i18n.get('common.weekdays.t_N_' + weekdays[i]);
        }
      }
      // Prüfen, ob es nicht ausgewählte Wochentage gibt, sonst "täglich" als String setzen
      if(selWeekDays.indexOf("0") == -1){
        wdStatusText = Hafas.Modules.i18n.get('Push.index.t_N_DailySubscription');
      }
      data.repeatStatus = 'weekdays';
      data.repeatStatusText = wdStatusText;
      data.repeatStatusTextLong = wdStatusTextLong;
    }
    return data;
  },
  updateWeekdaySelection: function(){
     var weekdayString = '';
     Hafas('input[data-push-selection="weekdays"]',true).forEach(function (wdCheckbox) {
         if(wdCheckbox.checked){
           weekdayString += '1';
         }else{
           weekdayString += '0';
         }
     });
     var currSubscr = this.Controller.Push.currentSubscription;
     this.Controller.Push.temporaryWeekdaySelection = weekdayString;
  },
  acceptRepeatOptions: function(data){
    var currSubscr = this.Controller.Push.currentSubscription;
    this.Controller.Push.weekdaySelection = this.Controller.Push.temporaryWeekdaySelection;
    this.Controller.Push.temporaryWeekdaySelection = null;

    var weekdayString = this.Controller.Push.weekdaySelection;
    if(typeof currSubscr.serviceDays == 'undefined'){
      currSubscr.serviceDays = {};
    }
    currSubscr.serviceDays.selectedWeekdays = weekdayString;

    if(typeof currSubscr.conSubscr != 'undefined'){
      currSubscr.conSubscr.serviceDays.selectedWeekdays = weekdayString;
    }
    if(weekdayString != null && weekdayString.indexOf("1") == -1){
      delete this.Controller.Push.weekdaySelection;
      if(typeof currSubscr.conSubscr != 'undefined') {
        delete currSubscr.conSubscr.serviceDays.selectedWeekdays;
      }
      delete currSubscr.serviceDays.selectedWeekdays;
    }

    // Schritt aus der History löschen
    Hafas.Modules.History.removeCurrentStep("repeatOptions");
    if(this.appContext != 'TP') {
      Hafas.bind(this.Controller.Push.renderEditDialog, this)();
    }else{
      Hafas.bind(this.Controller.TP.renderCreateAlarm,this)(data)
    }
  },
  pauseAlarms: function(boolval){
      var user = this.Controller.Push.getCurrentAlarmCenterUser();
      Hafas.Modules.Pushservice.getUserDetails({
        userId: user.userId
      },Hafas.bind(function(userDetails) {
        var userResult = userDetails.svcResL[0].res;
        var hfsTimeNow = Hafas.Core.newType("hafasTime", {jsDate: new Date()});
        var hciDateTime = Hafas.Util.date.hfsTimeToISO(hfsTimeNow);
        var pauseOptions = {
          userId: user.userId,
          options: {}
        };
        if(typeof userResult.availableChannels != 'undefined') {
          pauseOptions.options.availableChannels = userResult.availableChannels;
        }
        if(typeof userResult.channels != 'undefined') {
          pauseOptions.options.channels = userResult.channels;
        }
        if(typeof userResult.language != 'undefined') {
          pauseOptions.options.language = userResult.language;
        }
        if(boolval){
          pauseOptions.options.pauseBegin = hciDateTime;
        }
        Hafas.Modules.Pushservice.updateUser(pauseOptions, function(updateResult){

        }, function(err){

        });
      },this));
  },
  reRenderView: function(){
     Hafas.ps.pub('/app/events/resize',[]);
  },
  closeView: function(histData){
    switch (histData.view) {
      case "subscriptionHistory":
      case "edit": Hafas.ps.pub('/GUI/results/overview/hide', [{}]);break;
    }
  },
  restoreView: function(histData){
    var view = histData.view;
    switch (view) {
      case "index":
        Hafas.ps.pub('/GUI/form/show', [{}]);
        Hafas.bind(this.Controller.Push.renderIndex, this)(histData.data);break;
      case "edit":
        Hafas.bind(this.Controller.Push.showEditDialog, this)(histData.data);
    }
  },
  cleanup: function(){
    Hafas("#Push_Result" ).innerHTML = "";
    this.Controller.Push.currentSubscription = null;
    this.Controller.Push.temporaryWeekdaySelection = null;
    this.Controller.Push.weekdaySelection = null;
    Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
    Hafas.ps.pub('/GUI/results/details/hide', [{}]);
    Hafas.ps.pub('/GUI/form/hide', [{}]);
  }
}



